export { API, axios, getSession, handleOtherResponseCode, Image, Loading, motion, NextServerCookies, 
         PAGE_ANIMATION_OPTIONS, REDIRECT, signIn, SUCCESS_REPONSE_CODE, toastr, TRANSLATION, 
         UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, useEffect, useRouter, 
         useState, useTranslation, Yup, CustomToastrAction, clearSWRCache, useSWR, ErrorPages} from '@/imports-files/common/common';


export { default as React, Component } from "react";
//-----------Custom Component----------------
export { default as Logo} from "@/components/logo";

export { default as Modal} from '@/components/modal';

export { default as Button} from "@/components/button";

//-----------Custom Component----------------

// ----------------------------- SERVICES ---------------------------------------
export {SendRequest} from '@/services/common/send-request';
export {InviteClientAdmin} from '@/services/pages/clients/invite-admin';
// ----------------------------- SERVICES ---------------------------------------

// ----------------------------- CONSTANTS ---------------------------------------
export {CLIENT_NAME} from '@/constants/pages/clients/invite-admin';
// ----------------------------- CONSTANTS ---------------------------------------


//-----------Stylesheet----------------
export { default as ButtonStyle } from '@/styles/components/button/_index.module.scss';
export { default as Classes } from '@/styles/pages/clients/success/_index.module.scss';
export { default as Stylesheet} from '@/styles/pages/clients/invite-admin/_index.module.scss';
export { default as InputStyles} from '@/styles/components/input-field/_index.module.scss';
export { default as BackStyle} from '@/styles/pages/admins/login/_index.module.scss';
//-----------Stylesheet----------------

export {inviteAdminFormSubmit} from '@/actions/pages/clients/invite-admin';
export {clientRoles, roles} from '@/actions/pages/admins/dashboard/clients/add-users';
export {InputError} from '@/actions/common/input-error';

// ----------------Fontawesome icons -----------------
export { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export { faTimes,faArrowLeft } from '@fortawesome/free-solid-svg-icons';
// ----------------Fontawesome icons -----------------

export { default as Link } from 'next/link';
